import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export type OnboardTenantRequest = {
  businessName: string;
  contactEmail: string;
  contactFirstName: string;
  contactLastName: string;
  locationName: string;
  locationAddress: string;
  locationCity: string;
  locationProvince: string;
  locationCountry?: string;
  locationTimezone?: string;
  sportCodes: string[];
  platformFeePercent?: number;
  planTier?: string;
  currency?: string;
};

export type OnboardTenantResponse = {
  tenantId: string;
  tenantSlug: string;
  locationId: string;
  locationSlug: string;
  operatorUserId: string;
  inviteEmailSentTo: string;
  message: string;
};

export function useOnboardTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: OnboardTenantRequest) =>
      apiClient<OnboardTenantResponse>('/platform/tenants', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform-tenants'] });
    },
  });
}

export function useSetPassword() {
  return useMutation({
    mutationFn: (body: { token: string; newPassword: string }) =>
      apiClient<{ message: string }>('/auth/set-password', {
        method: 'POST',
        skipAuth: true,
        body: JSON.stringify(body),
      }),
  });
}
